import {HttpRequest, HttpEvent, HttpResponse, HttpInterceptorFn, HttpHandlerFn} from '@angular/common/http';
import {map, Observable} from 'rxjs';

//Format date
const formatDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?/;

//Interception de la requête HTTP
//  Paramètres
//    request : Requête HTTP
//    next    : Gestionnaire suivant
//  Retourne
//    Résultat de l’interception
export const ConvertirHttpDateInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) : Observable<HttpEvent<any>> =>
{
  let retourInterception: Observable<HttpEvent<any>>;

  retourInterception = next (req).pipe (map ((val: HttpEvent<any>) =>
                                             {
                                               if (val instanceof HttpResponse)
                                               {
                                                 const body = val.body;
                                                 Convertir (body);
                                               }

                                               return val
                                             }));

  return retourInterception;
}

//Convertit les données du corps de la requête
//  Paramètres
//    body : Corps de la requête
function Convertir (body: any) : void 
{
  if (body && typeof body === 'object')
  {
    for (const key of Object.keys (body)) 
    {
      const value = body[key];

      if (ControlerDate (value)) 
        body[key] = new Date(value);
      else 
        if (typeof value === 'object')
          Convertir (value);
    }
  }
}
  
//Contrôle si la valeur est une date
//  Paramètres
//    value : Valeur
//  Retourne
//    Vrai si la valeur est une date
function ControlerDate (value: any) : boolean 
{
  let estUneDate;

  if (value && typeof value === 'string')
    estUneDate = formatDate.test (value);
  else
    estUneDate = false;
    
  return estUneDate;
}  
